const order = {
    state: {
        goodsOrder: [], // 存储结算页面订单信息
        cartIds: []
    },
    mutations: {    //更新
        GET_GOODS_ORDER (state, newInfo) {
            state.goodsOrder = newInfo    //更改信息
        },
        GET_CART_IDS (state, newInfo) {
            state.cartIds = newInfo
        }
    },
    actions: {
        updateGoodsOrder ({ commit, state }, newInfo) {
            commit('GET_GOODS_ORDER', newInfo)
        },
        updateCartIds({ commit, state }, newInfo) {
            commit('GET_CART_IDS', newInfo)
        }
    }
}

export default order